import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'

const stats = [
  {
    number: 5,
    label: 'anos de experiência',
    prefix: '+',
  },
  {
    number: 100,
    label: 'projetos concluídos',
    prefix: '+',
  },
  {
    number: 50,
    label: 'clientes satisfeitos',
    prefix: '+',
  },
  {
    number: 99,
    label: 'de aprovação',
    suffix: '%',
  },
]

export default function Stats() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.1 }
    )

    const element = document.getElementById('stats')
    if (element) {
      observer.observe(element)
    }

    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  }, [])

  return (
    <section id="stats" className="bg-[#3b4b96] py-4">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-around items-center">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center px-4"
            >
              <span className="block text-3xl font-bold text-white">
                {stat.prefix}
                {isVisible ? stat.number : 0}
                {stat.suffix}
              </span>
              <p className="mt-1 text-sm text-[#e6e9f5]">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}